// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact .type {
  display: grid;
  place-content: center;
  width: 250px;
  border: 1px solid var(--gc-border-color);
  border-radius: var(--v-border-radius);
  position: relative;
}
.contact .type .hover-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  display: none;
}
.contact .type:hover .hover-icon {
  display: initial;
}

v-dropdown.no-border {
  --dropdown-border: none;
}

.meta {
  display: flex;
  gap: 5px;
  border-radius: var(--input-text-border-radius);
  border: var(--input-text-border) !important;
}

.input-container {
  position: relative;
  flex-grow: 1;
}
.input-container .error {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  color: var(--gc-error-color);
}`, "",{"version":3,"sources":["webpack://./src/app/steppers/users/steps/person/person.step.sass"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,qBAAA;EACA,YAAA;EACA,wCAAA;EACA,qCAAA;EAEA,kBAAA;AADR;AAEQ;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AAAZ;AAEY;EACI,gBAAA;AAAhB;;AAEA;EACI,uBAAA;AACJ;;AACA;EACI,aAAA;EACA,QAAA;EACA,8CAAA;EACA,2CAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,YAAA;AAGJ;AAFI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,4BAAA;AAIR","sourcesContent":[".contact\n    .type\n        display: grid\n        place-content: center\n        width: 250px\n        border: 1px solid var(--gc-border-color)\n        border-radius: var(--v-border-radius)\n    \n        position: relative\n        .hover-icon\n            position: absolute\n            right: 0.75rem\n            top: 0.75rem\n            display: none\n        &:hover\n            .hover-icon\n                display: initial\n\nv-dropdown.no-border\n    --dropdown-border: none\n\n.meta\n    display: flex\n    gap: 5px\n    border-radius: var(--input-text-border-radius)\n    border: var(--input-text-border) !important\n\n.input-container\n    position: relative\n    flex-grow: 1\n    .error\n        position: absolute\n        right: 0.75rem\n        top: 0.75rem\n        color: var(--gc-error-color)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
